<template>
  <div
    class="w-72 max-lg:bg-white max-lg:hidden max-lg:min-h-screen max-lg:px-8 max-lg:fixed max-lg:top-0 max-lg:left-0 max-lg:z-50"
    :class="{ 'max-lg:!block': filterState }"
  >
    <div class="hidden mt-6 mb-10 max-lg:!flex max-lg:justify-between">
      <h2 class="text-xl font-bold">{{ $t('page.filter') }}</h2>
      <button
        @click="$emit('closeFilter', true)"
        class="absolute right-5 rounded p-1.5 bg-[#F8F8F8] hover:bg-[#F0F0F0] ease-linear transition-all duration-150"
      >
        <IconClose></IconClose>
      </button>
    </div>
    <div class="divide-y-2 overflow-y-auto max-lg:h-[90vh]">
      <div class="mb-4">
        <div class="overflow-y-scroll fltrs">
          <ul class="space-y-3 row-list">
            <li v-if="!hideFilters.includes('currentHasDiscount')">
              <div class="flex items-center justify-between gap-2 text-red-500">
                <p class="font-bold max-md:font-sm uppercase">{{ $t('page.discount') }}</p>
                <label for="has_discount" class="relative inline-flex items-center cursor-pointer">
                  <input
                    type="checkbox"
                    id="has_discount"
                    :true-value="true"
                    :false-value="false"
                    @input="e => handleCheckbox(e, 'has_discount')"
                    class="sr-only peer"
                  />
                  <div
                    class="w-11 h-6 bg-[#E2E2E2] peer-focus:outline-none rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-accent-color"
                  ></div>
                </label>
              </div>
            </li>
            <li v-if="!hideFilters.includes('currentIsPromotion')">
              <div class="flex items-center justify-between gap-2 text-red-500">
                <p class="font-bold max-md:font-sm uppercase">{{ $t('page.promotion') }}</p>
                <label for="in_promotion" class="relative inline-flex items-center cursor-pointer">
                  <input
                    type="checkbox"
                    id="in_promotion"
                    :true-value="true"
                    :false-value="false"
                    @input="e => handleCheckbox(e, 'in_promotion')"
                    class="sr-only peer"
                  />
                  <div
                    class="w-11 h-6 bg-[#E2E2E2] peer-focus:outline-none rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-accent-color"
                  ></div>
                </label>
              </div>
            </li>
            <li v-if="!hideFilters.includes('currentIsNew')">
              <div class="flex items-center justify-between gap-2 text-green-500">
                <p class="font-bold max-md:font-sm uppercase">{{ $t('page.new') }}</p>
                <label for="new" class="relative inline-flex items-center cursor-pointer">
                  <input
                    type="checkbox"
                    id="new"
                    :true-value="true"
                    :false-value="false"
                    @input="e => handleCheckbox(e, 'is_new')"
                    class="sr-only peer"
                  />
                  <div
                    class="w-11 h-6 bg-[#E2E2E2] peer-focus:outline-none rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-accent-color"
                  ></div>
                </label>
              </div>
            </li>
          </ul>
        </div>
      </div>
      <div v-if="!hideFilters.includes('currentCategory')">
        <p class="font-semibold text-xl mb-4">{{ $t('nav.menu') }}</p>
        <div class="h-96 overflow-y-scroll fltrs">
          <ul class="space-y-4 row-list">
            <router-link
              class="text-main-color text-base font-semibold hover:text-accent-color"
              :class="{ '!text-accent-color': currentCategory == null }"
              :to="{
                name: routeName,
                query: {
                  category: null,
                  subscription: currentSubscription,
                  is_vip: isVip,
                  ordering: currentSort,
                  price__range: priceQuery,
                  is_new: currentIsNew,
                  in_promotion: currentIsPromotion,
                  has_discount: currentHasDiscount,
                  location: location,
                },
              }"
              >{{ $t('page.all') }}</router-link
            >
            <li v-for="cat in $store.exhibitionCategories" :key="cat?.id">
              <router-link
                class="text-main-color text-base font-semibold hover:text-accent-color"
                :class="{ 'text-accent-color': cat?.id == currentCategory }"
                :to="{
                  name: routeName,
                  query: {
                    category: cat?.id,
                    subscription: currentSubscription,
                    is_vip: isVip,
                    ordering: currentSort,
                    price__range: priceQuery,
                    is_new: currentIsNew,
                    in_promotion: currentIsPromotion,
                    has_discount: currentHasDiscount,
                    location: location,
                  },
                }"
                >{{ cat?.name }}</router-link
              >
              <ul class="ml-5 space-y-3 row-list font-normal">
                <li v-for="sub in cat.subcategories" :key="sub?.id">
                  <router-link
                    class="font-normal text-main-color text-base hover:text-accent-color"
                    :class="{ 'text-accent-color': sub?.id == currentCategory }"
                    :to="{
                      name: routeName,
                      query: {
                        category: sub?.id,
                        subscription: currentSubscription,
                        is_vip: isVip,
                        ordering: currentSort,
                        price__range: priceQuery,
                        is_new: currentIsNew,
                        in_promotion: currentIsPromotion,
                        has_discount: currentHasDiscount,
                        location: location,
                      },
                    }"
                  >
                    {{ sub?.name }}</router-link
                  >
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </div>
      <div v-if="!hideFilters.includes('currentSubscription')" class="my-5 py-5">
        <p class="font-semibold text-xl mb-4">{{ $t('page.status') }}</p>
        <div class="overflow-y-scroll fltrs">
          <ul class="space-y-3 row-list">
            <li>
              <router-link
                class="text-main-color text-base font-semibold hover:text-accent-color"
                :class="{ '!text-accent-color': currentSubscription == null }"
                :to="{
                  name: routeName,
                  query: {
                    category: currentCategory,
                    subscription: null,
                    is_vip: isVip,
                    ordering: currentSort,
                    price__range: priceQuery,
                    is_new: currentIsNew,
                    in_promotion: currentIsPromotion,
                    has_discount: currentHasDiscount,
                    location: location,
                  },
                }"
                >{{ $t('page.all') }}</router-link
              >
            </li>
            <li>
              <router-link
                class="text-main-color text-base font-semibold hover:text-accent-color"
                :class="{ '!text-accent-color': currentSubscription == 1 }"
                :to="{
                  name: routeName,
                  query: {
                    category: currentCategory,
                    subscription: 1,
                    is_vip: isVip,
                    ordering: currentSort,
                    price__range: priceQuery,
                    is_new: currentIsNew,
                    in_promotion: currentIsPromotion,
                    has_discount: currentHasDiscount,
                    location: location,
                  },
                }"
                >GOLD</router-link
              >
            </li>
            <li>
              <router-link
                class="text-main-color text-base font-semibold hover:text-accent-color"
                :class="{ '!text-accent-color': currentSubscription == 2 }"
                :to="{
                  name: routeName,
                  query: {
                    category: currentCategory,
                    subscription: 2,
                    is_vip: isVip,
                    ordering: currentSort,
                    price__range: priceQuery,
                    is_new: currentIsNew,
                    in_promotion: currentIsPromotion,
                    has_discount: currentHasDiscount,
                    location: location,
                  },
                }"
                >SILVER</router-link
              >
            </li>
            <li>
              <router-link
                class="text-main-color text-base font-semibold hover:text-accent-color"
                :class="{ '!text-accent-color': currentSubscription == 3 }"
                :to="{
                  name: routeName,
                  query: {
                    category: currentCategory,
                    subscription: 3,
                    is_vip: isVip,
                    ordering: currentSort,
                    price__range: priceQuery,
                    is_new: currentIsNew,
                    in_promotion: currentIsPromotion,
                    has_discount: currentHasDiscount,
                    location: location,
                  },
                }"
                >BRONZE</router-link
              >
            </li>
            <li v-if="!hideFilters.includes('isVip')">
              <router-link
                class="text-main-color text-base font-semibold hover:text-accent-color"
                :class="{ '!text-accent-color': isVip == 'true' }"
                :to="{
                  name: routeName,
                  query: {
                    category: currentCategory,
                    subscription: currentSubscription,
                    is_vip: isVip == 'true' ? null : true,
                    ordering: currentSort,
                    price__range: priceQuery,
                    is_new: currentIsNew,
                    in_promotion: currentIsPromotion,
                    has_discount: currentHasDiscount,
                    location: location,
                  },
                }"
                >VIP</router-link
              >
            </li>
          </ul>
        </div>
      </div>
      <div v-if="!hideFilters.includes('currentPrice')" class="my-5 py-5">
        <p class="font-semibold">{{ $t('page.price') }}</p>
        <div class="mt-5">
          <!-- <Slider @change="handlePriceSlider" class="px-1" showTooltip="drag" :max="maxPrice"
              v-model="sli" /> -->
          <div class="flex gap-7 mt-5">
            <div class="flex flex-col">
              <label for="minPrice">{{ $t('page.min') }}</label>
              <input
                v-model.number="minPriceQuery"
                @input="debouncedOnChange"
                class="w-full font-medium text-sm py-1 px-3 rounded border border-solid border-gp-grey-90"
                type="number"
                name="minPrice"
                min="0"
                id="minPrice"
              />
            </div>
            <div class="flex flex-col">
              <label for="minPrice">{{ $t('page.max') }}</label>

              <input
                v-model.number="maxPriceQuery"
                @input="debouncedOnChange"
                class="w-full font-medium text-sm py-1 px-3 rounded border border-solid border-gp-grey-90"
                type="number"
                name="maxPrice"
                id="maxPrice"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="my-3 py-3">
        <button
          @click="clearFilter"
          class="bg-accent-color w-full py-2 rounded-md text-white hover:bg-main-color"
        >
          {{ $t('page.clear') }}
        </button>
      </div>
    </div>
  </div>
  <div
    class="fixed inset-0 hidden bg-gray-800 bg-opacity-50"
    :class="{ 'max-lg:!flex': filterState }"
  ></div>
</template>

<script>
import IconClose from '@icons/IconClose.vue';
import _debounce from 'lodash.debounce';
export default {
  name: 'FoodSide',
  components: {
    IconClose,
  },
  props: {
    routeName: {
      type: String,
      default: 'stores',
    },
    filterState: {
      type: Boolean,
      default: false,
    },
    hideFilters: {
      type: Array,
      default: [],
      required: false,
    },
    currentCategory: {
      type: [Number, String],
      default: undefined,
    },
    currentSubscription: {
      type: [Number, String],
      default: undefined,
    },
    isVip: {
      type: [Boolean, String],
      default: undefined,
    },
    currentPrice: {
      type: [Number, String],
      default: undefined,
    },
    currentIsNew: {
      type: [Boolean, String],
      default: undefined,
    },
    currentIsPromotion: {
      type: [Boolean, String],
      default: undefined,
    },

    currentHasDiscount: {
      type: [Boolean, String],
      default: undefined,
    },

    currentSort: {
      type: [Number, String],
      default: undefined,
    },
    location: {
      type: [Number, String],
      default: undefined,
    },
  },
  watch: {
    currentPrice: {
      //   immediate: true,
      async handler(newValue, oldValue) {
        if (newValue !== oldValue) {
          if (this.currentPrice) {
            let x = this.currentPrice.split('__');
            this.minPriceQuery = x[0];
            if (x.length > 1) {
              this.maxPriceQuery = x[1];
            }
          } else {
            this.minPriceQuery = null;
            this.maxPriceQuery = null;
            this.priceQuery = undefined;
          }
        }
      },
    },
  },
  data() {
    return {
      minPriceQuery: null,
      maxPriceQuery: null,
      priceQuery: undefined,
    };
  },
  methods: {
    clearFilter() {
      this.minPriceQuery = null;
      this.maxPriceQuery = null;
      this.priceQuery = undefined;

      this.$router.push({
        name: this.routeName,
        query: {
          category: this.currentCategory,
          ordering: this.currentSort,
          location: this.location,
        },
      });
    },
    handleCheckbox(e, name) {
      let query = {
        category: this.currentCategory,
        subscription: this.currentSubscription,
        is_vip: this.isVip,
        price__range: this.priceQuery,
        ordering: this.currentSort,
        brand: this.currentBrands,
        is_new: this.currentIsNew,
        in_promotion: this.currentIsPromotion,
        has_discount: this.currentHasDiscount,
        location: this.location,
      };
      if (e.target.checked) {
        query[name] = e.target.checked;
      } else {
        delete query[name];
      }
      this.$router.push({
        name: this.routeName,
        query: query,
      });
    },
    pushChanges() {
      if (this.minPriceQuery < 0 || this.minPriceQuery == null || this.minPriceQuery == '') {
        this.minPriceQuery = 0;
      }
      this.priceQuery = `${this.minPriceQuery}__${this.maxPriceQuery}`;
      if (!this.maxPriceQuery) {
        this.priceQuery = `${this.minPriceQuery}`;
      }
      this.$router.push({
        name: this.routeName,
        query: {
          category: this.currentCategory,
          subscription: this.currentSubscription,
          is_vip: this.isVip,
          price__range: this.priceQuery,
          ordering: this.currentSort,
          is_new: currentIsNew,
          in_promotion: currentIsPromotion,
          has_discount: currentHasDiscount,
          location: this.location,
        },
      });
    },
  },
  mounted() {},
  computed: {
    debouncedOnChange() {
      return _debounce(this.pushChanges, 500);
    },
  },
};
</script>
